import { useEffect } from 'react';
import ReactGA from 'react-ga4';

interface GAPageview {
  hitType: string;
  page: string;
}

const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID || 'G-YK63NYH8QX';

export const GoogleAnalytics = () => {
  // Safe fallback if router not available
  let location;
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { useLocation } = require('react-router-dom');
    location = useLocation();
  } catch (e) {
    location = { pathname: window.location.pathname, search: window.location.search };
  }

  useEffect(() => {
    if (!GA_TRACKING_ID) return;
    
    if (process.env.NODE_ENV === 'production') {
      ReactGA.initialize(GA_TRACKING_ID);
      
      const pageview: GAPageview = {
        hitType: 'pageview',
        page: location.pathname + location.search,
      };
      ReactGA.send(pageview);
    }
  }, [GA_TRACKING_ID]);

  useEffect(() => {
    if (!GA_TRACKING_ID || process.env.NODE_ENV !== 'production') return;
    
    const pageview: GAPageview = {
      hitType: 'pageview',
      page: location.pathname + location.search,
    };
    ReactGA.send(pageview);
  }, [location, GA_TRACKING_ID]);

  return null;
};

export default GoogleAnalytics;
